import Alpine from "alpinejs";
import AsyncAlpine from "async-alpine";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import validate from "@colinaut/alpinejs-plugin-simple-validate";
import "lazysizes";
import textFit from "./plugins/textFit.js";
import textFill from "./plugins/textFill.js";
import form from "./components/form.js";
import homeIntro from "./components/homeIntro.js";
import { toggleScrollLock } from "./utils/scrollLock.js";

document.documentElement.classList.remove("loading");

Alpine.plugin(AsyncAlpine);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(validate);
Alpine.plugin(textFit);
Alpine.plugin(textFill);

// Magic helper to get CSS custom property values
Alpine.magic("cssVar", () => {
  return (name) =>
    parseInt(getComputedStyle(document.documentElement).getPropertyValue(name));
});

// Magic helper to track Umami analytics events
Alpine.magic("track", () => (name, data) => {
  console.log("[Umami Track]", name, data ?? "");
  window.umami?.track(name, data);
});

// Magic helper for scroll locking (prevents jump when opening menu)
Alpine.magic("scrollLock", () => toggleScrollLock);

// Global stores
Alpine.store("menuOpen", false);
Alpine.store("searchOpen", false);
Alpine.store("headerReduced", false);

// Components
Alpine.data("form", form);
Alpine.data("homeIntro", homeIntro);

// Async components (lazy-loaded on first use)
Alpine.asyncData("advocates", () => import("./components/advocates.js"));
Alpine.asyncData("faq", () => import("./components/faq.js"));
Alpine.asyncData("twoColumnScroll", () =>
  import("./components/twoColumnScroll.js")
);

window.Alpine = Alpine;
Alpine.start();
